import React from 'react';
import ProjectEmbed from '../components/ProjectEmbed';

const RocketProject = () => (
    <ProjectEmbed
        title='Hybrid Rocket "Prometheus"'
        src="/projects/prometheus/hybrid-rocket-prometheus.html"
    />
);

export default RocketProject;
